export default __webpack_public_path__ + "static/media/header.3f9b4b46.png";